var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import AboutLicenseTab from "@/app/vues/admin/about-license-tab.vue";
import AboutAppTab from "@/app/vues/admin/about-app-tab.vue";
let AboutVue = class AboutVue extends Vue {
    constructor() {
        super(...arguments);
        this.activeTab = 0;
        this.loadingCount = 0;
    }
    created() {
        const tabIndex = this.visibleTabs.findIndex(tab => tab === this.$route.hash);
        this.activeTab = tabIndex >= 0 ? tabIndex : 0;
    }
    get working() {
        return this.loadingCount > 0;
    }
    /**
     * Hashes of the tabs that are actually rendered, in the same order as in
     * the template. Used to translate the b-tabs active index (which is based
     * on rendered tabs) to a hash.
     */
    get visibleTabs() {
        return ["#license", "#app"];
    }
    rememberSelectedTab() {
        const currentHash = this.visibleTabs[this.activeTab];
        if (!currentHash)
            return;
        history.replaceState(history.state, "", currentHash);
        this.$router.replace({ hash: currentHash });
    }
    onLoadingChanged(loading) {
        this.loadingCount += loading ? 1 : -1;
        if (this.loadingCount < 0)
            this.loadingCount = 0;
    }
};
__decorate([
    Watch("activeTab"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AboutVue.prototype, "rememberSelectedTab", null);
AboutVue = __decorate([
    Component({
        name: "AboutVue",
        components: {
            AboutLicenseTab,
            AboutAppTab
        }
    })
], AboutVue);
export default AboutVue;
